import axios from "axios";

export async function fetchPupilsWithCategories() {
    try {
        const response = await axios.get("/pupil/with-categories");

        return response.data;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка загрузки данных";
        throw new Error(text);
    }
}
